export const getTabletUrlPrefix = () => {
    return process.env.REACT_APP_TABLET_URL_PREFIX ?? '<error>';
}